import React from "react";
import Navigation from "../components/marketing/Navigation";
import HeroSection from "../components/marketing/HeroSection";
import FeatureSlider from "../components/marketing/FeatureSlider";
import ValueCards from "../components/marketing/ValueCards";
import PricingSection from "../components/marketing/PricingSection";
import FaqSection from "../components/marketing/FaqSection";
import ContactSection from "../components/marketing/ContactSection";
import Footer from "../components/marketing/Footer";
import PageMeta from "../components/common/PageMeta";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans selection:bg-amber-500 selection:text-white">
      <PageMeta
        title="Export Stuff - Global Trade & Ceramic Inventory Automation"
        description="Streamline international export documentation, quotation tracking, packing lists, and ceramic tile inventory management with the Export Stuff enterprise platform."
      />

      <Navigation />
      <HeroSection />
      <ValueCards />
      <FeatureSlider />
      <PricingSection />
      <FaqSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default LandingPage;
